export default [
    {
        id: 'specialists',
        to: '/specialists',
        name: 'Специалисты'
    },
    {
        id: 'shop',
        to: '/goods',
        name: 'Магазин',
    },
    {
        id: 'certificates',
        to: '/certificates',
        name: 'Сертификаты'
    },
    {
        id: 'faq',
        to: '/faq',
        name: 'Вопрос — ответ'
    },
    {
        id: 'contacts',
        to: '/contacts',
        name: 'Контакты'
    }
]
